'use client';

import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function JsonBlock(props) {
  const {
    value
  } = props;
  return /*#__PURE__*/_jsx("pre", {
    children: JSON.stringify(value, null, 2)
  });
}
export const renderDefaultTextPart = ({
  part
}) => /*#__PURE__*/_jsx("div", {
  children: part.text
});
if (process.env.NODE_ENV !== "production") renderDefaultTextPart.displayName = "renderDefaultTextPart";
export const renderDefaultReasoningPart = ({
  part
}) => /*#__PURE__*/_jsxs("details", {
  children: [/*#__PURE__*/_jsx("summary", {
    children: "Reasoning"
  }), /*#__PURE__*/_jsx("div", {
    children: part.text
  })]
});
if (process.env.NODE_ENV !== "production") renderDefaultReasoningPart.displayName = "renderDefaultReasoningPart";
function ToolRenderer(props) {
  const {
    part
  } = props;
  const {
    toolInvocation
  } = part;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      children: toolInvocation.title ?? toolInvocation.toolName
    }), /*#__PURE__*/_jsx("div", {
      children: toolInvocation.state
    }), toolInvocation.input !== undefined ? /*#__PURE__*/_jsx(JsonBlock, {
      value: toolInvocation.input
    }) : null, toolInvocation.output !== undefined ? /*#__PURE__*/_jsx(JsonBlock, {
      value: toolInvocation.output
    }) : null, toolInvocation.approval !== undefined ? /*#__PURE__*/_jsx(JsonBlock, {
      value: toolInvocation.approval
    }) : null, toolInvocation.errorText ? /*#__PURE__*/_jsx("div", {
      children: toolInvocation.errorText
    }) : null]
  });
}
export const renderDefaultToolPart = ({
  part
}) => /*#__PURE__*/_jsx(ToolRenderer, {
  part: part
});
if (process.env.NODE_ENV !== "production") renderDefaultToolPart.displayName = "renderDefaultToolPart";
export const renderDefaultDynamicToolPart = ({
  part
}) => /*#__PURE__*/_jsx(ToolRenderer, {
  part: part
});
if (process.env.NODE_ENV !== "production") renderDefaultDynamicToolPart.displayName = "renderDefaultDynamicToolPart";
export const renderDefaultFilePart = ({
  part
}) => {
  if (part.mediaType.startsWith('image/')) {
    return /*#__PURE__*/_jsx("img", {
      alt: part.filename ?? '',
      src: part.url
    });
  }
  return /*#__PURE__*/_jsx("a", {
    href: part.url,
    children: part.filename ?? part.url
  });
};
if (process.env.NODE_ENV !== "production") renderDefaultFilePart.displayName = "renderDefaultFilePart";
export const renderDefaultSourceUrlPart = ({
  part
}) => /*#__PURE__*/_jsx("a", {
  href: part.url,
  children: part.title ?? part.url
});
if (process.env.NODE_ENV !== "production") renderDefaultSourceUrlPart.displayName = "renderDefaultSourceUrlPart";
export const renderDefaultSourceDocumentPart = ({
  part
}) => /*#__PURE__*/_jsxs("div", {
  children: [part.title ? /*#__PURE__*/_jsx("div", {
    children: part.title
  }) : null, part.text ? /*#__PURE__*/_jsx("div", {
    children: part.text
  }) : null]
});
if (process.env.NODE_ENV !== "production") renderDefaultSourceDocumentPart.displayName = "renderDefaultSourceDocumentPart";
export const renderDefaultStepStartPart = () => /*#__PURE__*/_jsx("div", {
  role: "separator"
});
if (process.env.NODE_ENV !== "production") renderDefaultStepStartPart.displayName = "renderDefaultStepStartPart";
export const renderDefaultDataPart = ({
  part
}) => /*#__PURE__*/_jsx(JsonBlock, {
  value: part.data
});
if (process.env.NODE_ENV !== "production") renderDefaultDataPart.displayName = "renderDefaultDataPart";
export function getDefaultMessagePartRenderer(part) {
  switch (part.type) {
    case 'text':
      return renderDefaultTextPart;
    case 'reasoning':
      return renderDefaultReasoningPart;
    case 'tool':
      return renderDefaultToolPart;
    case 'dynamic-tool':
      return renderDefaultDynamicToolPart;
    case 'file':
      return renderDefaultFilePart;
    case 'source-url':
      return renderDefaultSourceUrlPart;
    case 'source-document':
      return renderDefaultSourceDocumentPart;
    case 'step-start':
      return renderDefaultStepStartPart;
    default:
      return part.type.startsWith('data-') ? renderDefaultDataPart : null;
  }
}